import { BROADCAST_SET_PROGRAM, GET_BROADCAST } from 'actions/Types';

function program(state = null, action) {
  if (action.type === `${BROADCAST_SET_PROGRAM}`) {
    return action.payload;
  }

  if (action.type === `${GET_BROADCAST}_SUCCESS`) {
    return action.payload.program || state;
  }

  return state;
}

export default program;
